import { Component, input, signal } from "@angular/core";
import { FloorplanPlasticSign } from "@domain/project/floorplan/floorplan-plastic-sign";
import { TabBarModule } from "@odx/angular/components/tab-bar";
import { FloorplanCustomPartNumbersComponent } from "@project/floorplanner/floorplan-custom-part-numbers/floorplan-custom-part-numbers.component";

@Component({
  selector: "app-floorplan-plastic-sign-detail-form",
  imports: [FloorplanCustomPartNumbersComponent, TabBarModule],
  templateUrl: "./floorplan-plastic-sign-detail-form.component.html",
  styleUrl: "./floorplan-plastic-sign-detail-form.component.scss",
})
export class FloorplanPlasticSignDetailFormComponent {
  readonly plasticSign = input.required<FloorplanPlasticSign>();
  protected readonly selectedTabIndex = signal<number>(0);
}
